import { render } from "./SkeletonInternetService.vue?vue&type=template&id=21a11214&scoped=true"
import script from "./SkeletonInternetService.vue?vue&type=script&lang=js"
export * from "./SkeletonInternetService.vue?vue&type=script&lang=js"

import "./SkeletonInternetService.vue?vue&type=style&index=0&id=21a11214&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21a11214"
/* hot reload */
if (module.hot) {
  script.__hmrId = "21a11214"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21a11214', script)) {
    api.reload('21a11214', script)
  }
  
  module.hot.accept("./SkeletonInternetService.vue?vue&type=template&id=21a11214&scoped=true", () => {
    api.rerender('21a11214', render)
  })

}

script.__file = "src/ui/skeleton/services/SkeletonInternetService.vue"

export default script